import type { CorporatePortalTestModeConfig } from "./CorporatePortalApi";

export const mockCorporatePortalTestModeConfig: CorporatePortalTestModeConfig = {
  enabled: false,
};
